// CN marketplace configurations related to cart scope.

// Cart tabs
export const CART_TABS = {
  ALL: {
    name: 'all',
    index: 0
  },
  DOTD: {
    name: 'dotd',
    index: 1
  },
  PRICE_DROP: {
    name: 'price_drop',
    index: 2
  },
  SOLD_OUT: {
    name: 'sold_out',
    index: 3
  }
};
